import {Normalizer, SnapshotEntity} from "../types";

// EGM (araç) sorgusu normalizer'ı.
//
// Girdi: DosyaBorcluEgmCevap (parse() sonrası şekliyle, bkz uyap/DosyaBorcluEgm.ts).
// Entity = araç. key = arac.plaka (maskeli, örn "06***51" — kararlı ve deterministik).
// plakaSifreli (volatil şifreli değer) ne key'e ne attrs'a ASLA girmez.
//
// arac.mahrumiyet üç hal alabilir: null (hiç sorgulanmadı ya da mahrumiyet sorgusu
// hata verdi), yarım/hatalı nesne ({message} gibi — output alanı yok) ya da dolu
// DosyaBorcluEgmMahrumiyetCevap (sorguSonucDVO.output: IMahrumiyet[]). Yalnız dolu
// ve en az bir kaydı olan halde şerh cümleleri üretilip attrs.mahrumiyet'e konur;
// diğer iki halde attrs.mahrumiyet hiç eklenmez (undefined bırakılır).
export const egmNormalizer: Normalizer = (cevap: any) => {
    const aracList = cevap?.sorguSonucDVO?.aracBilgileri?.aracList;

    if (!Array.isArray(aracList)) {
        // Beklenmeyen/eksik şekil: sorgu hiç çalışmamış ya da tanınmayan bir cevap.
        return {entities: []};
    }

    const entities: SnapshotEntity[] = aracList.map((arac: any) => aracEntityUret(arac));

    const aracSayisi = cevap?.sorguSonucDVO?.aracBilgileri?.aracSayisi;
    const ozet: Record<string, unknown> = {
        aracSayisi: typeof aracSayisi === "number" ? aracSayisi : entities.length
    };

    return {entities, ozet};
};

function aracEntityUret(arac: any): SnapshotEntity {
    const plaka = typeof arac?.plaka === "string" ? arac.plaka : "";

    const label = aracLabelUret(arac, plaka);

    const attrs: Record<string, unknown> = {};
    if (arac?.marka !== undefined) attrs.marka = arac.marka;
    if (arac?.model !== undefined) attrs.model = arac.model;
    if (arac?.cins !== undefined) attrs.cins = arac.cins;
    if (arac?.renk !== undefined) attrs.renk = arac.renk;
    if (arac?.ticariAd !== undefined) attrs.ticariAd = arac.ticariAd;
    if (arac?.hacizSerhi !== undefined) attrs.hacizSerhi = arac.hacizSerhi;

    const mahrumiyetCumleleri = mahrumiyetCumleleriUret(arac?.mahrumiyet);
    if (mahrumiyetCumleleri !== undefined) attrs.mahrumiyet = mahrumiyetCumleleri;

    return {key: plaka, label, attrs};
}

function aracLabelUret(arac: any, plaka: string): string {
    const parcalar = [arac?.marka, arac?.ticariAd].filter(
        (p) => typeof p === "string" && p.length > 0
    );

    if (parcalar.length === 0) {
        // label boş kalmasın diye key'e (plaka) düş.
        return plaka;
    }

    return `${parcalar.join(" ")} · ${plaka}`;
}

// arac.mahrumiyet doluysa (sorguSonucDVO.output en az bir kayıt içeriyorsa) her
// kayıttan insan-okur bir cümle üretir. null / {message} gibi yarım nesnelerde ya
// da boş output'ta undefined döner (attrs'a hiç eklenmesin diye).
function mahrumiyetCumleleriUret(mahrumiyet: any): string[] | undefined {
    const output = mahrumiyet?.sorguSonucDVO?.output;

    if (!Array.isArray(output) || output.length === 0) {
        return undefined;
    }

    const cumleler = output.map((m: any) => mahrumiyetCumleUret(m)).filter((c: string) => c.length > 0);

    return cumleler.length > 0 ? cumleler : undefined;
}

function mahrumiyetCumleUret(m: any): string {
    const parcalar: string[] = [];

    if (typeof m?.takyidatAdi === "string" && m.takyidatAdi) parcalar.push(m.takyidatAdi);
    if (typeof m?.ekleyenBirim === "string" && m.ekleyenBirim) parcalar.push(m.ekleyenBirim);
    if (typeof m?.evrakTarihi === "string" && m.evrakTarihi) parcalar.push(m.evrakTarihi);
    if (typeof m?.aciklama === "string" && m.aciklama) parcalar.push(m.aciklama);

    return parcalar.join(" · ");
}
